export const apiPath = '/api/catalogue/v1/frontend/catalogs';
export const adminApiPath = '/api/catalogue/v1/backend/catalogs';
export const searchApiPath = '/aisearch/ais_searchapi/ru/search/pgu/';
export const iconsApiPath = '/api/newsfeed/v4/frontend/json/ru/icons';
